module.exports = __webpack_public_path__ + "static/media/bestPresenter2.dd8a4cab.jpg";